import { useNavigate } from 'react-router-dom';
import { routes } from '~/constants';
import { useStore, useStoreActions } from '~/contexts';
import { useContactsMap } from '~/hooks/reactQuery/derived/useContactsMap';
import { useArchiveDraft } from '~/hooks/reactQuery/mutations/useArchiveDraft';
import { useDuplicateDraft } from '~/hooks/reactQuery/mutations/useDuplicateDraft';
import { usePreviewDraft } from '~/hooks/usePreviewDraft';
import { useScheduledProposalActions } from '~/hooks/useScheduledProposal';
import { useTerminateAgreement } from '~/hooks/useTerminateAgreement';
import { selectors } from '~/store/state-selectors';
export function useDraftRowActionsFor(param) {
    let { refresh } = param;
    const navigate = useNavigate();
    const { logBI } = useStoreActions();
    const { terminateDraftById } = useTerminateAgreement();
    const worksAt = useStore(selectors.user.business);
    const { contactsMap, sampleContact } = useContactsMap(worksAt === null || worksAt === void 0 ? void 0 : worksAt.id);
    const { archive } = useArchiveDraft({
        onSuccess: ()=>refresh()
    });
    const { duplicateDraft } = useDuplicateDraft({
        onSuccess: (newDraftId)=>navigate(routes.draft(newDraftId))
    });
    const { previewDraft } = usePreviewDraft({
        sampleContact,
        contactsMap
    });
    const scheduled = useScheduledProposalActions();
    return (param)=>{
        let { draftId, isSample, isScheduled } = param;
        const target = {
            draftId,
            isSampleRelationship: isSample,
            refresh
        };
        return {
            onEdit: ()=>{
                if (isScheduled) {
                    scheduled.showSwitchToEditModal(target);
                    return;
                }
                logBI(10352);
                navigate(routes.draft(draftId));
            },
            onPreview: ()=>previewDraft(draftId),
            onSendNow: ()=>scheduled.sendNow(target),
            onCancelScheduling: ()=>scheduled.cancelScheduledProposal(target),
            onDuplicate: ()=>duplicateDraft(draftId),
            onArchive: ()=>{
                logBI(18800);
                archive(draftId);
            },
            onDelete: ()=>terminateDraftById(draftId, ()=>refresh()),
            showSwitchToEditModal: ()=>scheduled.showSwitchToEditModal(target)
        };
    };
}
